import React, { Component, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { withMsal } from '@azure/msal-react';
import PrivateRoute from './components/route/PrivateRoute';
import {
  refreshTokenTimer,
  getAzurePhoto,
  msalInstance,
  originLocalStorage,
  loginRequest
} from './utilities';
import { doLogout as doLogoutHelper, sanitizeOriginHostname } from './utilities/Helper';
import { bindReturnUrl } from './utilities/Helper';
import { ApiService } from './constants';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { MsalContext } from '@azure/msal-react';
import { setAuthUser, setAuthFetch, showModal } from '../src/actions/auth';
import { fetchLandingConfig } from '../src/actions/config';
import {
  refreshAuthToken,
  startInterval,
  runningInterval,
  stopInterval
} from '../src/actions/refresh_token';
import './scss/App.scss';
import 'react-quill/dist/quill.snow.css';
import '@mantine/carousel/styles.css';
import Swal from 'sweetalert2';
import SplashScreen from './components/splashscreen';
import MasterLevelPage from './views/master_level';
import InventoryRewardPage from './views/inventory_reward';
import PointManagementPage from './views/point-management';
import MasterBadgePage from './views/badge';
import MasterMissionPage from './views/mission';
import Notif from './views/notification';
import RnbMission from './views/rnb-mission';
import SearchPage from './views/search';
import RnbRedeem from './views/redeem-user';
import DetailRedeem from './views/detail-redeem';
import TransaksiRedeemPage from './views/transaksi_redeem';
import DashboardExecutivePage from './views/dashboard_executive';
import DetailSearchPage from './views/search/detail';
import SyncUser from './views/sync-user';
import ResetWidget from './views/reset-widget';
import ProfileDetailRedeem from './views/detail-redeem-user-profile';
import ReportGamificationPage from './views/report-gamification';
import ListSyncUserPage from './views/list_sync_user';
import InjectPoint from './views/inject-point';
import DetailUserReportGamification from './views/detail-report-gamification';
import DashboardPrincipalPage from './views/dashboard_principal';
import SearchUmumPage from './views/search_umum';
import DetailSearchUmumPage from './views/search_umum/detail';
import EditEvaluationSharingSession from './views/self_report/bcld_review/EditEvaluationSharingSessionReview';
import EvaluationSharingSession from './views/self_report/bcld_review/EvaluationSharingSessionReview';
import RaterFormEditPage from './views/management_edit_rater_form';
import ManagementExpectationFormEditPage from './views/management_expectation_form_edit';
import TaskDelegation from './views/task-delegation';
import TaskDelegationAdmin from './views/task-delegation/index-admin';
import NewTaskDelegation from './views/task-delegation/new-task-delegation';
import NewTaskDelegationAdmin from './views/task-delegation/new-task-delegation-admin';
import EditTaskDelegation from './views/task-delegation/edit-task-delegation';
import EditTaskDelegationAdmin from './views/task-delegation/edit-task-delegation-admin';
import AdminRaterFormInputPage from './views/admin_rater_form_input';
import AdmnExpecForm from './views/admin_expectation_form_input';
import DetailEvaluationSharingSession from './views/self_report/bcld_review/DetailEvaluationSharingSession';
import PrincipalRaterFormDetailPage from './views/principal_rater_form_detail';
import PrincipalExpectationFormDetailPage from './views/principal_expectation_form_detail';
import SyncCourseEnrollment from "./views/sync_course_enrollment";


declare interface IAppProps {
  authUser?: any;
  setAuthUser?: any;
  showModal?: any;
  setAuthFetch?: any;
  fetchLandingConfig?: any;
  startInterval?: any;
  runningInterval?: any;
  stopInterval?: any;
  refreshAuthToken?: any;
  msalContext?: any;
  auth?: any;
  refreshToken?: any;
  config?: any;
}

declare global {
  interface Window {
    jQuery: any;
  }
}

//main pages
const Home = React.lazy(() => import('./views/home'));
const Page = React.lazy(() => import('./views/page'));
const Logout = React.lazy(() => import('./views/logout/Logout'));
const LoginPortal = React.lazy(() => import('./views/login_portal'))

//admin pages
const Homepage = React.lazy(() => import('./views/homepage'));
const Dashboard = React.lazy(() => import('./views/my-learning/dashboard'));
const DashboardMyLearning = React.lazy(
    () => import('./views/dashboard/Dashboard')
);
const ViewBulkReport = React.lazy(() => import('./views/self_report/bulk_report_review_admin/ViewBulkReport'))
const ReportReviewDashboard = React.lazy(() => import('./views/self_report/report_review_dashboard'));
const BulkSelfReport = React.lazy(() => import('./views/self_report/bulk_report/BulkSelfReport'));
const BulkSelfReportAdmin = React.lazy(() => import('./views/self_report/bulk_report/BulkSelfReportAdmin'));
const BulkUploadSelfReport = React.lazy(() => import('./views/self_report/bulk_report/BulkSelfReport'))
const SelfReport = React.lazy(() => import('./views/self_report/SelfReport'));
const SelfReportDetail = React.lazy(() => import('./views/self_report/detail'));
const BcldReview = React.lazy(() => import('./views/self_report/bcld_review'));
const Event = React.lazy(() => import('./views/event/event/event-list'));
const EventDetail = React.lazy(() => import('./views/event/detail'));
const Events = React.lazy(() => import('./views/events/event/Event'));
const EventsForm = React.lazy(() => import('./views/events/event/EventForm'));
const EventsPreview = React.lazy(() => import('./views/eventspreview/preview'));
const MandatoryTrainingManagementPage = React.lazy(() => import('./views/mandatory-training-management'));
const MandatoryTrainingManagementEditPage = React.lazy(() => import('./views/mandatory-training-management/edit'))

const Role = React.lazy(() => import('./views/role_management'));
const RoleForm = React.lazy(
    () => import('./views/role_management/roles/RoleForm')
);

const Leader = React.lazy(() => import('./views/leader_wisdom/leaders/Leader'));
const LeaderForm = React.lazy(
    () => import('./views/leader_wisdom/leaders/LeaderForm')
);

const Personal = React.lazy(
    () => import('./views/personal_wisdom/personal/Personal')
);
const PersonalForm = React.lazy(
    () => import('./views/personal_wisdom/personal/PersonalForm')
);
const MyPersonal = React.lazy(() => import('./views/my_personal_wisdom'));

const Testimony = React.lazy(
    () => import('./views/testimony/testimony/Testimony')
);
const TestimonyForm = React.lazy(
    () => import('./views/testimony/testimony/TestimonyForm')
);
const MyTestimony = React.lazy(() => import('./views/my_testimony'));

const Content = React.lazy(() => import('./views/content/content/Content'));
const ContentForm = React.lazy(
    () => import('./views/content/content/ContentForm')
);
const ContentView = React.lazy(
    () => import('./views/content/content/ContentView')
);

const LandingForm = React.lazy(
    () => import('./views/landing_page/configuration')
);
const HomepageManagement = React.lazy(
    () => import('./views/homepage_management/configuration')
);
const FooterManagement = React.lazy(
    () => import('./views/footer_management/footer/FooterForm')
);

const TrainingCertificates = React.lazy(
    () => import('./views/training_certificates')
);
const DocumentViewer = React.lazy(() => import('./views/document_viewer'));

const MasterRaterPage = React.lazy(() => import('./views/master_rater'));
const ExpectationFormPage = React.lazy(
    () => import('./views/expectation_form')
);
const RaterFormPage = React.lazy(() => import('./views/rater_form'));
const ScheduleRaterPage = React.lazy(() => import('./views/schedule_rater'));
const RaterFormDetailPage = React.lazy(
    () => import('./views/rater_form_detail')
);
const ExpectationFormDetailPage = React.lazy(
    () => import('./views/expectation_form_detail')
);
const PrincipalRaterFormInputPage = React.lazy(
    () => import('./views/principal_rater_form_input')
);
const PrincipalExpectationFormPage = React.lazy(
    () => import('./views/principal_expectation_form')
);
const PrincipalRaterFormPage = React.lazy(
    () => import('./views/principal_rater_form')
);
const PrincipalExpectationFormInputPage = React.lazy(
    () => import('./views/principal_expectation_form_input')
);
const MasterCategoryContentPage = React.lazy(
    () => import('./views/master_category_content')
);

const ProfileUserPage = React.lazy(() => import('./views/profile_user'));
const EditProfileUserPage = React.lazy(
    () => import('./views/edit_profile_user')
);
const ChangePasswordPage = React.lazy(() => import('./views/change-password'));
const ListContentPage = React.lazy(() => import('./views/list_content'));
const ListRecommendationPage = React.lazy(
    () => import('./views/list_recommendation')
);
const DetailMissionPage = React.lazy(() => import('./views/detail-mission'));
const DashboardBCLDPage = React.lazy(() => import('./views/dashboard_bcld'));
const AddMission = React.lazy(() => import('./views/mission/add'));
const CaseStudyPage = React.lazy(() => import('./views/case-study'));
const AddCaseStudyPage = React.lazy(() => import('./views/case-study/add'));
const DetailCaseStudyPage = React.lazy(
    () => import('./views/case-study/detail')
);
const UserCaseStudyPage = React.lazy(() => import('./views/user/case-study'));
const UserDetailCaseStudyPage = React.lazy(
    () => import('./views/user/case-study/detail')
);
const AddUserCaseStudyPage = React.lazy(
    () => import('./views/user/case-study/add')
);
const UserOverviewPage = React.lazy(() => import('./views/user/overview'));
const UserTopicPage = React.lazy(() => import('./views/user/topic'));
const UserCreateTopicPage = React.lazy(() => import('./views/user/topic/add'));
const UserDetailTopicPage = React.lazy(
    () => import('./views/user/topic/detail')
);
const TopicPage = React.lazy(() => import('./views/topic'));
const EditTopicPage = React.lazy(() => import('./views/topic/edit'));
const DetailTopicPage = React.lazy(() => import('./views/topic/detail'));
const OverviewDetailCaseStudyPage = React.lazy(
    () => import('./views/user/overview/detail/caseStudy')
);
const OverviewDetailTopicPage = React.lazy(
    () => import('./views/user/overview/detail/topic')
);

declare interface IAppState {
  azurePhoto: string;
  loadingDelay?: Boolean;
}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.userData,
    config: state.config,
    refreshToken: state.refreshToken
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
      {
        setAuthUser,
        showModal,
        setAuthFetch,
        fetchLandingConfig,
        refreshAuthToken,
        startInterval,
        runningInterval,
        stopInterval
      },
      dispatch
  );
};

class App extends Component<IAppProps, IAppState> {
  constructor(props: Readonly<IAppProps>) {
    super(props);
    this.state = {
      azurePhoto: '',
      loadingDelay: false
    };
  }

  static contextType = MsalContext;
  context!: React.ContextType<typeof MsalContext>;

  async componentDidMount(): Promise<any> {
    let currentUrl = new URL(window.location.toString())
    let sanitizedOrigin = sanitizeOriginHostname(currentUrl.origin)

    if (currentUrl.origin !== sanitizedOrigin) {
      currentUrl.hostname = new URL(sanitizedOrigin).hostname
      window.location.href = currentUrl.toString()
    }

    //handle if set auth user error or reload browser manual by user
    this.props.setAuthFetch(false);

    this.props.fetchLandingConfig();
    this.handleAzureLogin(this);

    const redirect_after_login = window.localStorage.getItem(
        'redirect_after_login'
    );
    if (redirect_after_login) {
      this.setState({loadingDelay: true});
    }

    setTimeout(() => {
      window.localStorage.removeItem('redirect_after_login');
      this.setState({loadingDelay: false});
    }, 2000);
  }

  handleAzureLogin = async (self: this) => {
    try {
      const result = await self.context.instance.handleRedirectPromise();
      if (result) {
        msalInstance.setActiveAccount(result.account);
        // if login azure
        this.props.setAuthFetch(true);
        getAzurePhoto(
            self.context.instance,
            result.account,
            (base64DataUri: any) => {
              self._setAuthUserWithAzure(self, result, base64DataUri);
            },
            () => {
              self._setAuthUserWithAzure(self, result, '');
            }
        );
      }
    } catch (_) {
      await msalInstance.loginRedirect(loginRequest);
    }
  }

  _setAuthUserWithAzure = (SELF, res, azurePhoto) => {
    SELF.props
      .setAuthUser(res.account.username, null, azurePhoto)
      .then((result) => {
        if (result && result.userName) {
          setTimeout(() => {
            bindReturnUrl();
          }, 100);
        } else {
          Swal.fire({
            html: `Login failed,<br />please use your employee/lecturer email`,
            icon: 'warning'
          }).then(() => {
            doLogoutHelper();
          });
        }
      });
  };

  renderRouteNew = () => {
    return (
      <Suspense fallback={<SplashScreen />}>
        <Switch>
          <Route exact path="/" render={(props) => <Home />} />
          <Route
            exact
            path="/page/:id"
            render={(props) => <Page {...props} />}
          />
          <Route exact path="/logout" render={() => <Logout />} />
          <PrivateRoute
            exact
            path="/home"
            render={(props) => <Homepage {...this.props} />}
          />

          <PrivateRoute
            exact
            path="/dashboard/main/old"
            render={(props) => <DashboardMyLearning {...props} />}
          />

          <PrivateRoute
            exact
            path="/dashboard/main/new"
            render={(props) => <Dashboard {...props} />}
          />

          <PrivateRoute
            exact
            path="/dashboard/main"
            render={(props) => <Dashboard {...props} />}
          />

          <PrivateRoute
            exact
            path="/management/report-gamification/overview-binusian"
            render={(props) => <DetailUserReportGamification {...props} />}
          />
          <PrivateRoute
            exact
            path="/management/inject-point"
            render={(props) => <InjectPoint {...props} />}
          />

          <PrivateRoute
            exact
            path="/dashboard/self-report"
            render={(props) => <SelfReport {...props} />}
          />
          <PrivateRoute
            exact
            path="/dashboard/bulk-upload"
            render={(props) => <BulkUploadSelfReport {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/dashboard/self-report/:id"
            render={(props) => <SelfReport {...props} />}
          />
          <PrivateRoute
            exact
            path="/dashboard/self-report/review/:id/:type"
            render={(props) => <SelfReportDetail {...props} />}
          />
          <PrivateRoute
            exact
            path="/dashboard/bulk-self-report"
            render={() => <BulkSelfReport {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/management/bcld-review"
            render={() => <ReportReviewDashboard {...this.props} />}
          />
          <PrivateRoute
              exact
              path="/management/sync-course-enrollment"
              render={() => <SyncCourseEnrollment />}
          />
          <PrivateRoute
            exact
            path="/management/bulk-self-report"
            render={() => <BulkSelfReportAdmin {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/management/bcld-review/view-bulk-report/"
            render={() => <ViewBulkReport {...this.props} />}
          />
          {/* <PrivateRoute
            exact
            path="/management/bcld-review"
            render={(props) => <BcldReview />}
          /> */}
          <PrivateRoute
            exact
            path="/management/sync-user"
            render={(props) => <SyncUser />}
          />
          <PrivateRoute
            exact
            path="/management/history-sync-user"
            render={(props) => <ListSyncUserPage />}
          />
          <PrivateRoute
            exact
            path="/management/reset-widget"
            render={(props) => <ResetWidget />}
          />
          <PrivateRoute
            exact
            path="/management/bcld-review/:id/:type"
            render={(props) => <SelfReportDetail {...props} />}
          />
          <PrivateRoute
            exact
            path="/management/evaluation-sharing-session/:id/"
            render={(props) => <EvaluationSharingSession {...props} />}
          />
          <PrivateRoute
            exact
            path="/self-report/detail/evaluation-sharing-session/:id/"
            render={(props) => <DetailEvaluationSharingSession {...props} />}
          />
          <PrivateRoute
            exact
            path="/management/evaluation-sharing-session/edit/:id/"
            render={(props) => <EditEvaluationSharingSession {...props} />}
          />
          <PrivateRoute
            exact
            path="/dashboard/personal-wisdom"
            render={(props) => (
              <MyPersonal azurePhoto={this.props.auth.azurePhoto} />
            )}
          />

          <PrivateRoute
            exact
            path="/dashboard/testimony"
            render={(props) => (
              <MyTestimony {...props} azurePhoto={this.props.auth.azurePhoto} />
            )}
          />

          <PrivateRoute
            exact
            path="/event"
            render={(props) => <Event {...props} {...this.props} />}
          />

          <PrivateRoute
            exact
            path="/event/:id"
            render={(props) => <EventDetail {...props} {...this.props} />}
          />

          <PrivateRoute
            exact
            path="/management/events"
            render={(props) => <Events {...props} />}
          />

          <PrivateRoute
            exact
            path="/management/eventspreview"
            render={(props) => <EventsPreview {...props} />}
          />

          <PrivateRoute
            exact
            path="/management/events/:id"
            render={(props) => <EventsForm {...props} />}
          />

          <PrivateRoute
            exact
            path="/management/role"
            render={(props) => <Role />}
          />
          <PrivateRoute
            exact
            path="/management/role/form"
            render={(props) => <RoleForm {...props} />}
          />
          <PrivateRoute
            exact
            path="/management/role/form/:id"
            render={(props) => <RoleForm {...props} />}
          />

          <PrivateRoute
            exact
            path="/management/leader-wisdom"
            render={(props) => <Leader {...props} />}
          />
          <PrivateRoute
            exact
            path="/management/mission"
            render={(props) => <MasterMissionPage {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/management/leader-wisdom/form"
            render={(props) => <LeaderForm {...props} />}
          />
          <PrivateRoute
            exact
            path="/management/leader-wisdom/form/:id"
            render={(props) => <LeaderForm {...props} />}
          />

          <PrivateRoute
            exact
            path="/management/personal-wisdom"
            render={(props) => <Personal {...props} />}
          />
          <PrivateRoute
            exact
            path="/management/personal-wisdom/form"
            render={(props) => <PersonalForm {...props} />}
          />
          <PrivateRoute
            exact
            path="/management/personal-wisdom/form/:id"
            render={(props) => <PersonalForm {...props} />}
          />

          <PrivateRoute
            exact
            path="/management/testimony"
            render={(props) => <Testimony {...props} />}
          />
          <PrivateRoute
            exact
            path="/management/testimony/form"
            render={(props) => <TestimonyForm {...props} />}
          />
          <PrivateRoute
            exact
            path="/management/testimony/form/:id"
            render={(props) => <TestimonyForm {...props} />}
          />

          <PrivateRoute
            exact
            path="/management/content"
            render={(props) => <Content {...props} />}
          />
          <PrivateRoute
            exact
            path="/management/content/form"
            render={(props) => <ContentForm {...props} />}
          />
          <PrivateRoute
            exact
            path="/management/content/form/:id"
            render={(props) => <ContentForm {...props} />}
          />
          <PrivateRoute
            exact
            path="/management/content/view/:id"
            render={(props) => <ContentView {...props} />}
          />

          <PrivateRoute
            exact
            path="/management/landing-page"
            render={(props) => <LandingForm {...props} />}
          />

          <PrivateRoute
            exact
            path="/management/homepage-management"
            render={(props) => (
              <HomepageManagement {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/management/homepage-level"
            render={(props) => <MasterLevelPage {...props} {...this.props} />}
          />

          <PrivateRoute
            exact
            path="/management/master-level"
            render={(props) => <MasterLevelPage {...props} {...this.props} />}
          />

          <PrivateRoute
            exact
            path="/management/inventory-reward"
            render={(props) => (
              <InventoryRewardPage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/management/point-management"
            render={(props) => (
              <PointManagementPage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/management/master-rater"
            render={(props) => <MasterRaterPage {...props} {...this.props} />}
          />

          <PrivateRoute
            exact
            path="/management/expectation-form"
            render={(props) => (
              <ExpectationFormPage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/management/expectation-form/detail/:id"
            render={(props) => (
              <ExpectationFormDetailPage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/principal/expectation-form/detail/:id"
            render={(props) => (
              <PrincipalExpectationFormDetailPage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/management/rater-form"
            render={(props) => <RaterFormPage {...props} {...this.props} />}
          />

          <PrivateRoute
            exact
            path="/management/rater-form/detail/:id"
            render={(props) => (
              <RaterFormDetailPage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/principal/rater-form/detail/:id"
            render={(props) => (
              <PrincipalRaterFormDetailPage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/management/rater-form/detail/edit/:id/:userid"
            render={(props) => <RaterFormEditPage {...props} {...this.props} />}
          />

          <PrivateRoute
            exact
            path="/management/expectation-form/detail/edit/:id/:userid"
            render={(props) => (
              <ManagementExpectationFormEditPage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/management/schedule-rater"
            render={(props) => <ScheduleRaterPage {...props} {...this.props} />}
          />

          <PrivateRoute
            exact
            path="/management/footer"
            render={(props) => <FooterManagement {...props} />}
          />

          <PrivateRoute
            exact
            path="/management/master-category-content"
            render={(props) => (
              <MasterCategoryContentPage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/management/dashboard-bcld"
            render={(props) => <DashboardBCLDPage {...props} {...this.props} />}
          />

          <PrivateRoute
            exact
            path="/management/dashboard-executive"
            render={(props) => (
              <DashboardExecutivePage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/management/dashboard-principal"
            render={(props) => (
              <DashboardPrincipalPage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/principal/rater-form"
            render={(props) => (
              <PrincipalRaterFormPage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/principal/rater-form/input/:id"
            render={(props) => (
              <PrincipalRaterFormInputPage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/management/rater-form/input/:id/:userid"
            render={(props) => (
              <AdminRaterFormInputPage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/principal/expectation-form"
            render={(props) => (
              <PrincipalExpectationFormPage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/principal/expectation-form/input/:id"
            render={(props) => (
              <PrincipalExpectationFormInputPage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/management/expectation-form/input/:id/:userid"
            render={(props) => <AdmnExpecForm {...props} {...this.props} />}
          />

          <PrivateRoute
            exact
            path="/dashboard/certificates"
            render={(props) => <TrainingCertificates {...props} />}
          />

          <PrivateRoute
            exact
            path="/profile/edit-profile"
            render={(props) => (
              <EditProfileUserPage {...props} {...this.props} />
            )}
          />

          <PrivateRoute
            exact
            path="/profile"
            render={(props) => <ProfileUserPage {...props} {...this.props} />}
          />

          <PrivateRoute
            exact
            path="/list/:title/:type/:id"
            render={(props) => <ListContentPage {...props} {...this.props} />}
          />

          <PrivateRoute
            exact
            path="/recommendation/:type"
            render={(props) => (
              <ListRecommendationPage {...props} {...this.props} />
            )}
          />

          <Route
            exact
            path="/profile/change-password"
            render={(props) => <ChangePasswordPage {...props} />}
          />
          <PrivateRoute
            exact
            path="/management/badge"
            render={(props) => <MasterBadgePage {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/management/transaksi-redeem-reward"
            render={(props) => (
              <TransaksiRedeemPage {...props} {...this.props} />
            )}
          />
          <PrivateRoute
            exact
            path="/profile/notification"
            render={(props) => <Notif {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/rnb/mission"
            render={(props) => <RnbMission {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/rnb/redeem"
            render={(props) => <RnbRedeem {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/mission/:id"
            render={(props) => <DetailMissionPage {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/redeem/:id"
            render={(props) => <DetailRedeem {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/redeem-profile/:id"
            render={(props) => (
              <ProfileDetailRedeem {...props} {...this.props} />
            )}
          />
          <PrivateRoute
            exact
            path="/management/report-gamification"
            render={(props) => (
              <ReportGamificationPage {...props} {...this.props} />
            )}
          />
          <PrivateRoute
            exact
            path="/search"
            render={(props) => <SearchPage {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/search/detail"
            render={(props) => <DetailSearchPage {...props} {...this.props} />}
          />
          <Route
            exact
            path="/s"
            render={() => <SearchUmumPage/>}
          />
          <Route
            exact
            path="/s/d"
            render={(props) => (
              <DetailSearchUmumPage {...props} {...this.props} />
            )}
          />
          <PrivateRoute
            exact
            path="/management/mission/add"
            render={(props) => <AddMission {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/management/mission/edit/:id"
            render={(props) => <AddMission {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/management/case-study"
            render={(props) => <CaseStudyPage {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/management/case-study/create"
            render={(props) => <AddCaseStudyPage {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/management/case-study/edit/:id"
            render={(props) => <AddCaseStudyPage {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/management/case-study/detail/:id"
            render={(props) => (
              <DetailCaseStudyPage {...props} {...this.props} />
            )}
          />
          <PrivateRoute
            exact
            path="/snfm/case-study"
            render={(props) => <UserCaseStudyPage {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/snfm/case-study/create"
            render={(props) => (
              <AddUserCaseStudyPage {...props} {...this.props} />
            )}
          />
          <PrivateRoute
            exact
            path="/snfm/case-study/detail/:id"
            render={(props) => (
              <UserDetailCaseStudyPage {...props} {...this.props} />
            )}
          />
          <PrivateRoute
            exact
            path="/snfm/case-study/edit/:id"
            render={(props) => (
              <AddUserCaseStudyPage {...props} {...this.props} />
            )}
          />
          <PrivateRoute
            exact
            path="/snfm/overview"
            render={(props) => <UserOverviewPage {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/snfm/topic"
            render={(props) => <UserTopicPage {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/snfm/topic/create"
            render={(props) => (
              <UserCreateTopicPage {...props} {...this.props} />
            )}
          />
          <PrivateRoute
            exact
            path="/snfm/topic/edit/:id"
            render={(props) => (
              <UserCreateTopicPage {...props} {...this.props} />
            )}
          />
          <PrivateRoute
            exact
            path="/snfm/topic/detail/:id"
            render={(props) => (
              <UserDetailTopicPage {...props} {...this.props} />
            )}
          />
          <PrivateRoute
            exact
            path="/management/topic"
            render={(props) => <TopicPage {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/management/topic/detail/:id"
            render={(props) => <DetailTopicPage {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/management/topic/edit/:id"
            render={(props) => <EditTopicPage {...props} {...this.props} />}
          />
          <PrivateRoute
            exact
            path="/snfm/overview/detail/case-study/:id"
            render={(props) => (
              <OverviewDetailCaseStudyPage {...props} {...this.props} />
            )}
          />
          <PrivateRoute
            exact
            path="/snfm/overview/detail/topic/:id"
            render={(props) => (
              <OverviewDetailTopicPage {...props} {...this.props} />
            )}
          />
          <PrivateRoute
            exact
            path="/management/mandatory-training"
            render={(props) => (
              <MandatoryTrainingManagementPage/>
            )}
          />
          <PrivateRoute
            exact
            path="/management/mandatory-training/edit/:id"
            render={(props) => (
              <MandatoryTrainingManagementEditPage/>
            )}
          />
          <Route
            exact
            path="/doc-viewer"
            render={(props) => <DocumentViewer {...props} />}
          />
          <Route
            path="/task-delegation"
            render={(props) => <TaskDelegation {...props} {...this.props} />}
          />
          <Route
            path="/task-delegation-admin"
            render={(props) => (
              <TaskDelegationAdmin {...props} {...this.props} />
            )}
          />

          <Route
            path="/new-task-delegation"
            render={(props) => <NewTaskDelegation {...props} {...this.props} />}
          />
          <Route
            path="/new-task-delegation-admin"
            render={(props) => (
              <NewTaskDelegationAdmin {...props} {...this.props} />
            )}
          />
          <Route
            path="/edit-task-delegation"
            render={(props) => (
              <EditTaskDelegation {...props} {...this.props} />
            )}
          />
          <Route
            path="/edit-task-delegation-admin"
            render={(props) => (
              <EditTaskDelegationAdmin {...props} {...this.props} />
            )}
          />
          {/* <PrivateRoute
            exact
            path='/dashboard/self-report/view-doc/:id/:type'
            render={props => <SelfReportDetail {...props} />}
          /> */}

          {/**
           Beelajar domain redirects
           If applicable, please use regex
           */}
          <Route
            exact
            path="/verify_certificate"
            render={() => {
              const beelajarBaseURL = new URL(
                ApiService.beelajar.postRequestLogin
              ).origin;
              const pathName = window.location.pathname;
              const queryString = window.location.search;
              window.location.href = `${beelajarBaseURL}${pathName}${queryString}`;
              return null;
            }}
          />

          <Route
            path="/mod"
            render={() => {
              const beelajarBaseURL = new URL(
                ApiService.beelajar.postRequestLogin
              ).origin;
              const pathName = window.location.pathname;
              const queryString = window.location.search;
              window.location.href = `${beelajarBaseURL}${pathName}${queryString}`;
              return null;
            }}
          />

          <Route
            path="/course"
            render={() => {
              const beelajarBaseURL = new URL(
                ApiService.beelajar.postRequestLogin
              ).origin;
              const pathName = window.location.pathname;
              const queryString = window.location.search;
              window.location.href = `${beelajarBaseURL}${pathName}${queryString}`;
              return null;
            }}
          />
          <Route path="/auth/msal" render={() => <SplashScreen />} />
          <Route path="*" render={() => <Redirect to="/home" />} />
          <Route
              path="/login-portal"
              render={() => <LoginPortal/>}
          />
        </Switch>
      </Suspense>
    );
  };

  render() {
    if (this.props.auth && window.location.pathname !== '/logout' && originLocalStorage.getItem()) {
      if (!this.props.refreshToken.isRunning) {
        this.props.startInterval();
        refreshTokenTimer();
      }
    }

    return this.state.loadingDelay ? <SplashScreen /> : this.renderRouteNew();
  }
}

export default withMsal(connect(mapStateToProps, mapDispatchToProps)(App));
